export enum challengeTabsList {
    ACTIVE       = "active",
    UPCOMING      = "upcoming",
    RESULTS      = "results",

}


export function challengeTabsParams():object{

let tabsParams: { id: string, label: string }[] = [
    { "id": challengeTabsList.ACTIVE, "label": "Leaderboard" },
    { "id": challengeTabsList.UPCOMING, "label": "Upcoming" },
    { "id": challengeTabsList.RESULTS, "label": "Results" },
];
return tabsParams;

}